import { z } from 'zod'

export const COOKIE_STORAGE_ROOT_KEY = 'morpho.userSettings'

export const USER_SETTINGS_VERSION = 1

export type UserSettings = {
  version: number // Required version field
} & {
  [key in PageKey]?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- open per-page cookie JSON bag; each entry is re-validated with zod at read time
    [key: string]: any
  }
}

export enum PageKey {
  Root = 'root',
  Dashboard = 'dashboard',
  Earn = 'earn',
  Borrow = 'borrow',
  Vault = 'vault',
  VaultV2 = 'vaultV2',
  Market = 'market',
  Curator = 'curator'
}

export const UserSettingsSchema = z.object({
  version: z.coerce.number().refine(v => v === USER_SETTINGS_VERSION, {
    message: `Version must be exactly ${USER_SETTINGS_VERSION}`
  }),
  [PageKey.Root]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Dashboard]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Earn]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Borrow]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Vault]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.VaultV2]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Market]: z.record(z.string(), z.unknown()).optional(),
  [PageKey.Curator]: z.record(z.string(), z.unknown()).optional()
})

export const safeValidateUserSettings = (data: unknown): UserSettings | null => {
  try {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    const parsedData = JSON.parse(data as string)
    const result = UserSettingsSchema.safeParse(parsedData)

    if (result.success) {
      return result.data
    }
    return null
  } catch {
    return null
  }
}
